<template>
    <div>
        <el-dialog :title="title" :visible.sync="addVisible" width="460px" @open="dlgOpen" @close="closeDialog" @closed="dlgClosed" :close-on-click-modal="false" :modal-append-to-body="false">
            <div :style="dlgBody" v-if="addVisible" v-loading="loading" element-loading-text="拼命加载中...">
                <el-container style="height:100%">
                    <el-header style="height:auto;">
                        <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText"></el-input>
                    </el-header>
                    <el-main style="height:100%;padding:8px;width:100%">
                        <el-tree class="filter-tree" :data="returnData" :props="defaultProps" :filter-node-method="filterNode" node-key="id" :default-checked-keys="defaultCheckedKeys" :expand-on-click-node="false" :default-expand-all="true" :default-expanded-keys="defaultExpandedKeys" show-checkbox ref="orgTreeDlg" :check-strictly="isCascade">
                            <span class="custom-tree-node" slot-scope="{ node, data }" style="font-size:14px;">
                                <span v-if="data.parent_id == null || data.parent_id==''">
                                    <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                                <span v-else-if="data.type == 1 || data.type=='1'">
                                    <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                                <span v-else>
                                    <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                                </span>
                            </span>
                        </el-tree>
                    </el-main>
                </el-container>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCancel()">取 消</el-button>
                <el-button type="primary" @click="onSubmit('')" :disabled="btnDisabled">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import DialogResize from "@/utils/DialogResize.js";
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
export default {
    mixins: [DialogResize],
    data () {
        return {
            btnDisabled: false,
            overAllRow: {},
            catalog: "",
            roleId: "",
            title: "",
            filterText: "",
            editCheckId: "",
            operType: 1,
            addVisible: false,
            platformType: "",
            treeData: [],
            returnData: [],
            defaultExcludeId: "",
            defaultCheckedKeys: [],
            /** 默认展开的节点 */
            defaultExpandedKeys: [],
            loading: false,
            isCascade: true,
            defaultProps: {
                children: "subs",
                label: "name",
                isLeaf: "leaf"
            }
        };
    },
    watch: {
        filterText (val) {
            this.$refs.orgTreeDlg.filter(val);
        }
    },
    methods: {
        init (type, defaultId, excludeId, row, platformType, catalog) {
            this.loading = false;
            this.btnDisabled = false;
            this.addVisible = true;
            this.catalog = catalog;
            this.roleId = row.id;
            this.filterText = "";
            this.editCheckId = "";
            this.platformType = platformType;
            this.operType = type;
            this.defaultExcludeId = excludeId;
            this.defaultExpandedKeys = [];
            this.overAllRow = row;
            this.title = "菜单授权";
            this.defaultCheckedKeys = [];
            this.isCascade = true;
            this.loading = false;

            this.onloadGroup();

            //如果有默认的id 将选中已选过的id
            // if (defaultId) {
            //   this.defaultCheckedKeys.push(parseInt(defaultId));
            // }
        },
        //获取全部菜单项
        onloadGroup () {
            this.loading = true;
            this.btnDisabled = true;
            let param = {
                catalog: this.catalog
            };
            SettingApi.getClass()
                .onloadMenuGroup({
                    platformType: this.platformType,
                    catalog: this.catalog
                })
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$nextTick(() => {
                            this.returnData = res2.data.data;
                            this.$nextTick(() => {
                                this.getRoleMenus(this.roleId);
                            });
                        });
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
        },
        //根据ID查询已经授权的ID
        getRoleMenus (id) {
            // this.$mhttp.httpGet(
            //   this.$constant.API_NSC + "uc/roleMenu/roleMenus/" + id,
            //   null,
            //   "application/json"
            // );

            SettingApi.getClass()
                .getRoleMenusList(id)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        if (data != null && data != "" && data.length != 0) {
                            for (let i = 0; i < data.length; i++) {
                                this.defaultCheckedKeys.push(data[i].menuId);
                            }
                            // this.$refs.orgTreeDlg.setCheckedNodes([1, 2]);
                            this.$refs.orgTreeDlg.setCheckedKeys(this.defaultCheckedKeys);
                        }
                        this.isCascade = false;
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        filterNode (value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        onSubmit (formName) {
            this.loading = true;
            this.btnDisabled = true;
            let callData = {};
            let halfDataIds = [];
            // if (
            //   this.$refs.orgTreeDlg.getCheckedNodes() &&
            //   this.$refs.orgTreeDlg.getCheckedNodes().length > 0
            // ) {
            callData = this.$refs.orgTreeDlg
                .getCheckedNodes()
                .concat(this.$refs.orgTreeDlg.getHalfCheckedNodes());
            const item = this.overAllRow;
            let param = {
                id: item.id,
                code: item.code,
                name: item.name,
                level: item.level,
                remark: item.remark,
                roleId: item.id,
                roleMenuDtos: []
            };
            for (let i = 0; i < callData.length; i++) {
                let callDataDtos = {};
                if (callData[i].id != 0) {
                    callDataDtos.roleId = item.id;
                    callDataDtos.menuId = callData[i].id;
                    callDataDtos.readable = true;
                    callDataDtos.writable = true;
                    callDataDtos.modifiable = true;
                    callDataDtos.deletable = false;
                    callDataDtos.menuRange = 10;
                    param.roleMenuDtos.push(callDataDtos);
                }
            }

            SettingApi.getClass()
                .saveMenuRoles(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.$message.success("保存成功！");
                        this.loading = false;
                        this.btnDisabled = false;
                        //刷新右边列表数据
                        this.$parent.initData();
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
            // } else {
            //   this.$message({
            //     showClose: true,
            //     message: "请选择一条记录",
            //     type: "warning",
            //     duration: 2000
            //   });
            //   return;
            // }
            this.defaultCheckedKeys = [];
            this.$refs.orgTreeDlg.setCheckedKeys([]);
            this.addVisible = false;
        },
        onCancel () {
            this.defaultCheckedKeys = [];
            this.$refs.orgTreeDlg.setCheckedKeys([]);
            this.addVisible = false;
        },
        closeDialog () {
            this.defaultCheckedKeys = [];
            this.$refs.orgTreeDlg.setCheckedKeys([]);
            this.addVisible = false;
        }
    }
};
</script>





